/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';
import { ProgressInfo, StatsProgressBarData } from '../../interfaces/ecommerce/stats-progress-bar';

@Injectable()
export class StatsProgressBarService extends StatsProgressBarData {
  private progressInfoData: ProgressInfo[] = [
    {
      title: 'Today’s Income',
      value: 572900,
      activeProgress: 70,
      description: 'Better than last week (70%)',
    },
    {
      title: 'Today’s Appointment',
      value: 6378,
      activeProgress: 30,
      description: 'Better than last week (30%)',
    },
    {
      title: 'New Patients',
      value: 200,
      activeProgress: 55,
      description: 'Better than last week (55%)',
    },
  ];

  private progressInfoData2: ProgressInfo[] = [
    {
      title: 'Cardiology',
      value: 384,
      activeProgress: 70,
      description: 'Better than last week (70%)',
    },
    {
      title: 'Tuberculosis of bladder',
      value: 19,
      activeProgress: 30,
      description: 'Better than last week (30%)',
    },
    {
      title: 'Tuberculosis of bladder',
      value: 22,
      activeProgress: 55,
      description: 'Better than last week (55%)',
    },
  ];
  getProgressInfoData(): Observable<ProgressInfo[]> {
    return observableOf(this.progressInfoData);
  }

  getProgressInfoData2(): Observable<ProgressInfo[]> {
    return observableOf(this.progressInfoData2);
  }
}
